// auth.js
export const LOGOUT = 'LOGOUT';
export const SAVE_TOKEN = 'SAVE_TOKEN';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const UPDATE_USER = 'UPDATE_USER';
export const FETCH_BALANCE_SUCCESS = 'FETCH_BALANCE_SUCCESS';
export const FETCH_BALANCE_FAILURE = 'FETCH_BALANCE_FAILURE';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_SIDEBAR_OPEN = 'SET_SIDEBAR_OPEN';
export const ENABLE_MOBILE = 'ENABLE_MOBILE';
export const SET_SIDEBAR_COLLAPSED = 'SET_SIDEBAR_COLLAPSED';
export const SET_NAWEC_STATUS = 'SET_NAWEC_STATUS';
// lang.js
// export const SET_LOCALE = 'SET_LOCALE'
